import { render } from "./block-checkbox.vue?vue&type=template&id=175d5c08&ts=true"
import script from "./block-checkbox.vue?vue&type=script&lang=ts"
export * from "./block-checkbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__